
import type {WorkExportProps, WorkV4} from '../types';

export const getWorkExportProps = (work: WorkV4): WorkExportProps => ({
  /* Required by manifestation validation */
  type: work?.type,
  agents: work?.agents,
  literatureType: work?.literatureType,
  intellectualLevel: work?.intellectualLevel,
  /* Required by expression validation */
  languages: work?.languages,
});
